import { useInventoryStore } from "../stores/inventory";
import { mergeLiveInventoryWithPermissions } from "../utils/inventoryVisibility";

export default {
  computed: {
    legacyDewarData() {
      const inventoryStore = useInventoryStore();
      const liveTree = inventoryStore.buildLegacyTree(this.appStore.state.activeUser?.labId);
      return mergeLiveInventoryWithPermissions(
        liveTree,
        this.appStore.state.inventoryPermissions,
        this.appStore.state.dewarData
      );
    },
  },
};
